import {
  Component,
  AfterViewInit,
  Input,
  ViewChild,
  NgZone,
  forwardRef,
  HostListener,
} from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';

declare const CKEDITOR: any;

@Component({
  selector: 'app-ck-editor',
  standalone: true,
  template: `<textarea #editor></textarea>`,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CkEditorComponent),
      multi: true,
    },
  ],
})
export class CkEditorComponent implements AfterViewInit {
  @Input() config = {
    extraPlugins: 'mathjax',
    mathJaxLib: '//cdnjs.cloudflare.com/ajax/libs/mathjax/2.7.0/MathJax.js?config=TeX-AMS_HTML',
  };
  @Input() inline = false;
  @Input() readonlyData = false;
  @Input() readonly = false;
  @ViewChild('editor', { static: false }) editor: any;
  instance;
  _value: '';
  zone: NgZone;

  get value(): any {
    return this._value;
  }

  @Input() set value(v) {
    if (v !== this._value) {
      this._value = v;
      this.onChange(v);
    }
  }

  constructor(zone: NgZone) {
    this.zone = zone;
  }

  ngAfterViewInit() {
    this.ckEditorInit(this.config || {});
  }

  private ckEditorInit(config) {
    if (typeof CKEDITOR === 'undefined' || !this.editor?.nativeElement) {
      return;
    }

    try {
      if (this.readonly) {
        config.readOnly = this.readonly;
      }
      if (this.inline) {
        CKEDITOR.disableAutoInline = true;
        this.instance = CKEDITOR.inline(this.editor.nativeElement, config);
      } else {
        this.instance = CKEDITOR.replace(this.editor.nativeElement, config);
      }

      if (!this.instance) {
        return;
      }

      if (this.readonly) {
        this.instance.setData(this.readonlyData);
      } else {
        this.instance.setData(this.value);
      }

      this.instance.on('change', () => {
        this.updateValue(this.instance.getData());
      });

      this.instance.on('instanceReady', () => {
        if (this.readonly) {
          this.instance.ui.editor.container.$.style = 'pointer-events: none;';
        }
      });
    } catch (error) {
      console.error(error);
    }
  }

  @HostListener('document:keydown', ['$event'])
  handleEscapeKeyboardEvent(event: KeyboardEvent) {
    if (event.keyCode === 27 && this.inline && this.instance) {
      this.instance.ui.editor.container.$.blur();
    }
  }

  private updateValue(value: any) {
    this.zone.run(() => {
      this.value = value;
    });
  }

  writeValue(value: any) {
    this._value = value;
    if (this.instance) {
      this.instance.setData(value);
    }
  }

  onChange(_: any) {}

  onTouched() {}

  registerOnChange(fn: any) {
    this.onChange = fn;
  }

  registerOnTouched(fn: any) {
    this.onTouched = fn;
  }
}
